<script>
  import { useNavigate } from "svelte-navigator";
  import { onMount } from "svelte";

  export let to = "/";
  export let replace = true;

  const navigate = useNavigate();

  onMount(() => {
    navigate(to, { replace });
  });
</script>
